import { Box, Stack, Typography } from '@mui/material';
import { CodeBlock } from '../CodeBlock';
import { Eyebrow, Prose, Section, TextLink, monoSm } from './Section';
import { PLATE } from './copy';
import sample from '../../data/sample-result.json';

const HEADING_ID = 'plate-title';

/** The plate caption: provenance read from the response itself, never typed in. */
function Caption() {
  const probed = sample.probed_at.slice(0, 10);
  return (
    <Box sx={{ ...monoSm, display: 'flex', flexWrap: 'wrap', columnGap: 1, rowGap: 0.5 }}>
      <Box component="span">
        {sample.payments.length} {PLATE.caption.methods}
      </Box>
      <Box component="span" aria-hidden="true">·</Box>
      <Box component="span">
        {PLATE.caption.probed} {probed}
      </Box>
    </Box>
  );
}

export function AcceptsPlate() {
  return (
    <Section labelledBy={HEADING_ID}>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: '5fr 7fr' },
          columnGap: { md: 8 },
          rowGap: { xs: 5, md: 0 },
          alignItems: 'start',
        }}
      >
        <Box sx={{ order: { xs: 2, md: 1 } }}>
          <Eyebrow>{PLATE.eyebrow}</Eyebrow>
          <Typography variant="h2" id={HEADING_ID} sx={{ mb: 2 }}>
            {PLATE.title}
          </Typography>
          <Typography sx={{ color: 'var(--ink-muted)', maxWidth: '68ch' }}>
            {PLATE.body}
          </Typography>

          <Stack spacing={3} sx={{ mt: 4 }}>
            {PLATE.facts.map((fact) => (
              <Box key={fact.title}>
                <Typography variant="h4" component="h3" sx={{ mb: 0.5 }}>
                  {fact.title}
                </Typography>
                <Typography variant="body2" sx={{ color: 'var(--ink-muted)', maxWidth: '60ch' }}>
                  <Prose parts={fact.body} />
                </Typography>
              </Box>
            ))}
          </Stack>

          <TextLink to={PLATE.link.to} sx={{ display: 'inline-block', mt: 4, fontSize: '0.875rem' }}>
            {PLATE.link.label}
          </TextLink>
        </Box>

        <Box sx={{ order: { xs: 1, md: 2 }, mt: { xs: 0, md: -2 }, minWidth: 0 }}>
          <CodeBlock
            code={JSON.stringify(sample, null, 2)}
            language="json"
            maxHeight={560}
            copyable={false}
          />
          <Caption />
        </Box>
      </Box>
    </Section>
  );
}
